import HOC from '../HOC';
import {business_insider} from '../utility';

let Business = () => {return null;}

export default HOC(Business, business_insider);



// WEBPACK FOOTER //
// ./src/components/News/Business.js